<template>
    <div class="workstation-form">
        <div class="top-buttons">
            <ui5-button @click="back()">{{ trans('pages.form_workstation_types.back_to_overview') }}</ui5-button>
            <ui5-button
                @click="save()"
                :disabled="saving"
            >
                <div>
                    <spinner v-if="saving" />
                    <div>{{ trans('pages.form_workstation_types.save') }}</div>
                </div>
            </ui5-button>
        </div>
        <img
            v-if="loading"
            class="spinner"
            src="css/images/ajax-loader-large.gif"
        />
        <form v-else>
            <div class="field">
                <ui5-label required>Sleutel</ui5-label>
                <ui5-input
                    :disabled="saving"
                    type="Text"
                    :value="key"
                    @input="key = $event.target.value"
                ></ui5-input>
                <div
                    v-if="getErrorFromValidator($v.key).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.key) }}
                </div>
            </div>
            <div class="field">
                <ui5-label required>Label</ui5-label>
                <ui5-input
                    :disabled="saving"
                    type="Text"
                    :value="label"
                    @input="label = $event.target.value"
                ></ui5-input>
                <div
                    v-if="getErrorFromValidator($v.label).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.label) }}
                </div>
            </div>
            <div class="field">
                <ui5-label>Omschrijving</ui5-label>
                <ui5-input
                    :disabled="saving"
                    type="Text"
                    :value="description"
                    @input="description = $event.target.value"
                ></ui5-input>
                <div
                    v-if="getErrorFromValidator($v.description).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.description) }}
                </div>
            </div>
            <div class="field color-field">
                <ui5-label required>Kleur</ui5-label>
                <div class="color-picker-container">
                    <div>
                        <ui5-color-picker
                            :disabled="saving"
                            :color="color"
                            @change="color = $event.target.color"
                        ></ui5-color-picker>
                    </div>
                </div>
                <div
                    v-if="getErrorFromValidator($v.color).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.color) }}
                </div>
            </div>
            <div class="field">
                <ui5-label required>Volgorde</ui5-label>
                <text-input
                    :disabled="saving"
                    type="number"
                    v-model="order"
                />
                <div
                    v-if="getErrorFromValidator($v.order).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.order) }}
                </div>
            </div>
            <div class="field">
                <ui5-label required>Type</ui5-label>
                <auto-complete-input
                    v-if="typeOptions"
                    v-model="workstationTypeId"
                    :initial-search="getLabel(workstationTypeId, typeOptions)"
                    :options="typeOptions"
                    placeholder="Werkposttype"
                />
                <div
                    v-if="getErrorFromValidator($v.workstationTypeId).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.workstationTypeId) }}
                </div>
            </div>
            <div class="field">
                <ui5-label>Aangepast scherm</ui5-label>
                <ui5-input
                    readonly
                    type="Text"
                    :value="customView"
                    @input="customView = $event.target.value"
                ></ui5-input>
                <div
                    v-if="getErrorFromValidator($v.customView).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.customView) }}
                </div>
            </div>
            <div class="field">
                <ui5-label required>Zichtbaar bij werkposten</ui5-label>
                <ui5-checkbox
                    :disabled="saving"
                    :checked="visible"
                    @change="visible = $event.target.checked"
                ></ui5-checkbox>
                <div
                    v-if="getErrorFromValidator($v.visible).length"
                    class="error"
                >
                    {{ getErrorFromValidator($v.visible) }}
                </div>
            </div>
            <div class="field status-updates-field">
                <ui5-label>Statusupdates bij aanvang</ui5-label>
                <div class="status-updates">
                    <template
                        v-for="($vUpdate, index) in $v.statusUpdates.$each
                            .$iter"
                    >
                        <div
                            :disabled="saving"
                            class="status-update"
                            v-if="
                                $vUpdate.$model.after == false &&
                                $vUpdate.$model.removed == false
                            "
                            :key="'statusUpdate1.' + index"
                        >
                            <ui5-select
                                :disabled="saving"
                                @change="
                                    $vUpdate.$model.updateStatusCode =
                                        $event.detail.selectedOption.value ||
                                        null
                                "
                            >
                                <ui5-option
                                    v-for="statusOption in statusOptions"
                                    :key="statusOption.value"
                                    :selected="
                                        $vUpdate.$model.updateStatusCode ==
                                        statusOption.value
                                    "
                                    :value="statusOption.value"
                                >
                                    {{ statusOption.label }}
                                </ui5-option>
                            </ui5-select>
                            <ui5-label>indien productstatus</ui5-label>
                            <ui5-select
                                :disabled="saving"
                                class="cmp"
                                @change="
                                    $vUpdate.$model.cmp =
                                        $event.detail.selectedOption.value ||
                                        null
                                "
                            >
                                <ui5-option
                                    v-for="cmpOption in cmpOptions"
                                    :key="cmpOption.value"
                                    :selected="
                                        $vUpdate.$model.cmp == cmpOption.value
                                    "
                                    :value="cmpOption.value"
                                >
                                    {{ cmpOption.label }}
                                </ui5-option>
                            </ui5-select>
                            <ui5-select
                                :disabled="saving"
                                @change="
                                    $vUpdate.$model.cmpStatusCode =
                                        $event.detail.selectedOption.value ||
                                        null
                                "
                            >
                                <ui5-option
                                    v-for="statusOption in [
                                        { value: null, label: '' },
                                        ...statusOptions,
                                    ]"
                                    :key="statusOption.value"
                                    :selected="
                                        $vUpdate.$model.cmpStatusCode ==
                                        statusOption.value
                                    "
                                    :value="statusOption.value"
                                >
                                    {{ statusOption.label }}
                                </ui5-option>
                            </ui5-select>
                            <i
                                class="fa fa-trash"
                                @click="removeStatusUpdate($vUpdate.$model)"
                            />
                            <div
                                v-if="getErrorFromValidator($vUpdate).length"
                                class="error"
                            >
                                {{ getErrorFromValidator($vUpdate) }}
                            </div>
                        </div>
                    </template>
                    <div class="add-new">
                        <ui5-button @click="addNewStatusUpdate(false)">
                            +
                        </ui5-button>
                    </div>
                </div>
            </div>
            <div class="field status-updates-field">
                <ui5-label>Statusupdates bij afwerken</ui5-label>
                <div class="status-updates">
                    <template
                        v-for="($vUpdate, index) in $v.statusUpdates.$each
                            .$iter"
                    >
                        <div
                            class="status-update"
                            v-if="
                                $vUpdate.$model.after == true &&
                                $vUpdate.$model.removed == false
                            "
                            :key="'statusUpdate2.' + index"
                        >
                            <ui5-select
                                :disabled="saving"
                                @change="
                                    $vUpdate.$model.updateStatusCode =
                                        $event.detail.selectedOption.value ||
                                        null
                                "
                            >
                                <ui5-option
                                    v-for="statusOption in statusOptions"
                                    :key="statusOption.value"
                                    :selected="
                                        $vUpdate.$model.updateStatusCode ==
                                        statusOption.value
                                    "
                                    :value="statusOption.value"
                                >
                                    {{ statusOption.label }}
                                </ui5-option>
                            </ui5-select>
                            <ui5-label>indien productstatus</ui5-label>
                            <ui5-select
                                :disabled="saving"
                                class="cmp"
                                @change="
                                    $vUpdate.$model.cmp =
                                        $event.detail.selectedOption.value ||
                                        null
                                "
                            >
                                <ui5-option
                                    v-for="cmpOption in cmpOptions"
                                    :key="cmpOption.value"
                                    :selected="
                                        $vUpdate.$model.cmp == cmpOption.value
                                    "
                                    :value="cmpOption.value"
                                >
                                    {{ cmpOption.label }}
                                </ui5-option>
                            </ui5-select>
                            <ui5-select
                                :disabled="saving"
                                @change="
                                    $vUpdate.$model.cmpStatusCode =
                                        $event.detail.selectedOption.value ||
                                        null
                                "
                            >
                                <ui5-option
                                    v-for="statusOption in [
                                        { value: null, label: '' },
                                        ...statusOptions,
                                    ]"
                                    :key="statusOption.value"
                                    :selected="
                                        $vUpdate.$model.cmpStatusCode ==
                                        statusOption.value
                                    "
                                    :value="statusOption.value"
                                >
                                    {{ statusOption.label }}
                                </ui5-option>
                            </ui5-select>
                            <i
                                class="fa fa-trash"
                                @click="removeStatusUpdate($vUpdate.$model)"
                            />
                            <div
                                v-if="getErrorFromValidator($vUpdate).length"
                                class="error"
                            >
                                {{ getErrorFromValidator($vUpdate) }}
                            </div>
                        </div>
                    </template>
                    <div class="add-new">
                        <ui5-button @click="addNewStatusUpdate(true)">
                            +
                        </ui5-button>
                    </div>
                </div>
            </div>
            <div class="field">
                <ui5-label>{{ trans('pages.form_workstation_types.print_identification_label') }}</ui5-label>
                <ui5-checkbox
                    id="print-identification-label-checkbox"
                    :checked="canPrintIdentificationLabel"
                    @change="
                        canPrintIdentificationLabel = $event.target.checked
                    "
                />
                <div
                    v-for="error in [getErrorFromValidator($v.canPrintIdentificationLabel)]"
                    v-if="error.length"
                    :key="'canPrintIdentificationLabel'"
                    class="error"
                >
                    {{ error }}
                </div>
            </div>
            <div class="field">
                <ui5-label>{{ trans('pages.form_workstation_types.pr_sticker_button') }}</ui5-label>
                <ui5-checkbox
                    id="print-pr-sticker-checkbox"
                    :checked="canPrintPrSticker"
                    @change="
                        canPrintPrSticker = $event.target.checked
                    "
                />
                <div
                    v-for="error in [getErrorFromValidator($v.canPrintPrSticker)]"
                    v-if="error.length"
                    :key="'canPrintPrSticker'"
                    class="error"
                >
                    {{ error }}
                </div>
            </div>
            <div class="field">
                <ui5-label>
                    {{ trans('pages.edit_workstation.check_colli_count_label') }}
                    <i
                        @mouseover="$refs.checkColliCountTooltip.showAt($event.target)"
                        @mouseout="$refs.checkColliCountTooltip.close()"
                        class="fa fa-question-circle"
                    />
                </ui5-label>
                <ui5-popover
                    ref="checkColliCountTooltip"
                    :allow-target-overlap="false"
                    placement-type="Bottom"
                >
                    <div>
                        {{ trans('pages.edit_workstation.check_colli_count_tooltip') }}
                    </div>
                </ui5-popover>
                <ui5-checkbox
                    :disabled="saving"
                    :checked="checkColliCount"
                    @change="checkColliCount = $event.target.checked"
                />
                <div
                    v-if="
                        getErrorFromValidator($v.checkColliCount).length
                    "
                    class="error"
                >
                    {{ getErrorFromValidator($v.checkColliCount) }}
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { required, maxLength, requiredIf } from 'vuelidate/lib/validators';
import ColorPickerMixin from './../../mixins/color-picker';
import localizationMixin from '../../mixins/localization';
import workstationApi from '../../api/workstation';
import statusApi from '../../api/status';
import Spinner from '../loader/Spinner';
import { showInfoMessage, showErrorMessage } from '../../dialogs';
import { getLabel } from '../../shared/collections';
import AutoCompleteInput from '../AutoCompleteInput';
import TextInput from '../TextInput.vue';

const cmpOptions = [
    { value: null, label: '' },
    { value: '=', label: '=' },
    { value: '!=', label: '!=' },
];

export default {
    components: { Spinner, AutoCompleteInput, TextInput },
    props: ['formType'],
    computed: {
        cmpOptions: () => cmpOptions,
        typeOptions() {
            if (!this.types) {
                return null;
            }
            return this.types.map((x) => ({
                value: x.id,
                label: x.externalName,
            }));
        },
    },
    mixins: [ColorPickerMixin, localizationMixin],
    data() {
        return {
            saving: false,
            loading: false,
            id: '',
            key: '',
            label: '',
            description: '',
            order: '',
            color: '',
            workstationTypeId: '',
            customView: '',
            types: null,
            visible: true,
            statusUpdates: [],
            statusOptions: [],
            canPrintIdentificationLabel: false,
            checkColliCount: false,
            canPrintPrSticker: false,
        };
    },
    mounted() {
        this.loading = true;
        const promises = [];
        if (this.formType == 'add') {
            this.workstationTypeId = this.$route.query.typeId;
        } else {
            promises.push(
                workstationApi
                    .fetchById(this.$route.params.id)
                    .then((response) => {
                        const station = response.data.data;
                        this.id = station.id;
                        this.key = station.key;
                        this.label = station.label;
                        this.description = station.description;
                        this.order = station.order;
                        this.color = station.color;
                        this.workstationTypeId = station.workstationTypeId;
                        this.customView = station.customView;
                        this.visible = station.visible;
                        this.statusUpdates = station.statusUpdates.map((x) => ({
                            ...x,
                            removed: false,
                        }));
                        this.canPrintIdentificationLabel =
                            station.canPrintIdentificationLabel;
                        this.checkColliCount = station.checkColliCount;
                        this.canPrintPrSticker =
                            station.canPrintPrSticker;
                    })
                    .catch(() => {
                        showErrorMessage(
                            'Onbekende fout bij ophalen van werkpost'
                        );
                    })
            );
        }

        promises.push(
            workstationApi
                .fetchAllTypes('externalName', false)
                .then((response) => {
                    this.types = response.data.data;
                })
                .catch(() => {
                    showErrorMessage(
                        'Onbekende fout bij ophalen van werkposttypes'
                    );
                })
        );

        promises.push(
            statusApi.fetchAllStatuses().then((response) => {
                const statusOptions = response.data.data.map((x) => {
                    return {
                        value: x.code,
                        label: x.external_name + ' (' + x.code + ')',
                    };
                });

                this.statusOptions = statusOptions;
            })
        );

        Promise.all(promises).then(() => {
            this.loading = false;
        });
    },
    validations() {
        return {
            id: {},
            key: {
                required: required,
                maxLength: maxLength(50),
            },
            label: {
                required: required,
                maxLength: maxLength(50),
            },
            description: {
                maxLength: maxLength(65535),
            },
            order: {
                required: required,
            },
            color: {
                required: required,
                maxLength: maxLength(45),
            },
            workstationTypeId: {
                required: required,
            },
            customView: {},
            visible: {},
            statusUpdates: {
                $each: {
                    updateStatusCode: {
                        updateStatusRequired: required,
                    },
                    cmp: {
                        cmpRequiresCmpId: requiredIf((update) => {
                            return update.cmpStatusCode != null;
                        }),
                    },
                    cmpStatusCode: {
                        cmpStatusCodeRequiresCmp: requiredIf((update) => {
                            return update.cmp != null;
                        }),
                    },
                },
            },
            canPrintIdentificationLabel: {},
            checkColliCount: {},
            canPrintPrSticker: {},
        };
    },
    methods: {
        getLabel,
        removeStatusUpdate(update) {
            if (!this.saving) {
                update.removed = true;
            }
        },
        addNewStatusUpdate(after) {
            this.statusUpdates.push({
                id: null,
                workstationId: this.workstationId,
                updateStatusCode: this.statusOptions[0].value,
                cmp: null,
                cmpStatusCode: null,
                after,
                removed: false,
            });
        },
        back() {
            this.$router.push('/settingsworkstationtypes');
        },
        save() {
            let valid = true;
            [this, ...Object.values(this.$refs).flat()].forEach((x) => {
                if (x.$v) {
                    x.$v.$touch();
                    if (x.$v.$invalid) {
                        valid = false;
                    }
                }
            });

            if (!valid) {
                showErrorMessage('Los eerst alle invoerfouten op');
            } else {
                const successCallback = () => {
                    showInfoMessage('De werkpost werd opgeslagen', () => {
                        this.$router.push('/settingsworkstationtypes');
                    });
                };

                const payload = {
                    id: this.id,
                    key: this.key,
                    label: this.label,
                    description: this.description,
                    order: this.order,
                    color: this.color,
                    workstationTypeId: this.workstationTypeId,
                    customView: this.customView,
                    visible: this.visible,
                    statusUpdates: this.statusUpdates.filter((x) => !x.removed),
                    removedStatusUpdates: this.statusUpdates
                        .filter((x) => x.removed && x.id != null)
                        .map((x) => x.id),
                    canPrintIdentificationLabel:
                        this.canPrintIdentificationLabel,
                    checkColliCount: this.checkColliCount,
                    canPrintPrSticker:
                        this.canPrintPrSticker,
                };

                this.saving = true;
                if (this.formType == 'add') {
                    workstationApi
                        .createWorkstation(payload)
                        .then(successCallback)
                        .catch(() => {
                            showErrorMessage(
                                'Onbekende fout bij het aanmaken van de werkpost'
                            );
                            this.saving = false;
                        });
                } else {
                    workstationApi
                        .updateWorkstation(payload)
                        .then(successCallback)
                        .catch(() => {
                            showErrorMessage(
                                'Onbekende fout bij het bijwerken van de werkpost'
                            );
                            this.saving = false;
                        });
                }
            }
        },
        getErrorFromValidator(validator) {
            if (!validator || !validator.$invalid) {
                return false;
            }

            if (!validator.$dirty) {
                return false;
            }

            if (validator.required === false) {
                return 'verplicht';
            }
            if (validator.maxLength === false) {
                return 'maxlengte ' + validator.$params.maxLength.max;
            }
            if (validator.isUnique === false) {
                return 'moet uniek zijn';
            }
            if (validator.minValue === false) {
                return 'min ' + validator.$params.minValue.max;
            }

            if (
                (validator.cmp && validator.cmp.cmpRequiresCmpId === false) ||
                (validator.cmpStatusCode &&
                    validator.cmpStatusCode.cmpStatusCodeRequiresCmp === false)
            ) {
                return 'vergelijkingsoperator en vergelijkingsstatus kunnen enkel samen ingesteld worden';
            }

            if (
                validator.updateStatusCode &&
                validator.updateStatusCode.updateStatusRequired == false
            ) {
                return 'nieuwe status is verplicht';
            }

            return false;
        },
    },
};
</script>
